import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Bind from 'lodash-decorators/bind';

import { injectIntl } from 'react-intl';

import messages from './Intro.intl';

import styles from './Intro.module.scss';

import { Container } from 'common/components/Layout/Layout';
import NavList from './Components/NavList/NavList';
import CompanyBox from './Components/CompanyBox/CompanyBox';
import ReportBox from './Components/ReportBox/ReportBox';

import CompaniesStore from 'stores/Companies';
import { LARGE_NUMBER_OF_ITEMS } from 'common/consts/common';

@injectIntl
@observer
export default class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlideIndex: 0,
      activeSlideIndexNext: 0,
      fadeInActive: false
    };

    this.companies = CompaniesStore.companies;
  }

  render() {
    const { activeSlideIndex } = this.state;

    const company = CompaniesStore.companies.find(
      c => c.codename === 'tenderhut'
    );

    if (!company) {
      return null;
    }

    return (
      <div>
        <Container className={styles.Container}>
          <div className={styles.ContentWrapper}>
            <div className={styles.CompanyBox}>
              <h1
                className={styles.CompanyTitle}
                style={{
                  color: company.color
                }}
              >
                {company.name}
              </h1>
              <p className={styles.CompanyParagraph}>{company.sneakPeak}</p>
            </div>
            <ReportBox className={styles.ReportBox} />
            <p className={styles.BackgroundText}>{company.name}</p>
          </div>
        </Container>

        <Container className={styles.ContainerFixedFloat}>
          <div className={styles.HeaderWrapper}>
            <div
              className={`${styles.Header} ${
                this.companies.length > LARGE_NUMBER_OF_ITEMS
                  ? styles.LotCompanies
                  : ''
              }`}
            >
              <h3 className={styles.HeaderTitle}>
                {this.props.intl.formatMessage(messages.heading)}
              </h3>
              <NavList
                companies={this.companies}
                setActiveSlide={this.setActiveSlide}
                activeSlideIndex={activeSlideIndex}
                className={styles.HeaderList}
                fadeInActive={this.state.fadeInActive}
              />
            </div>
          </div>
        </Container>
        <div
          className={styles.BackgroundContainer}
          style={{
            backgroundColor: this.companies[activeSlideIndex].color
          }}
        >
          <Container>
            <div className={styles.SectionGroupWrapper}>
              <CompanyBox
                companies={this.companies[activeSlideIndex]}
                isFadeInActive={this.isFadeInActive}
                activeSlideIndex={activeSlideIndex}
              />
            </div>
          </Container>
        </div>
      </div>
    );
  }

  @Bind()
  isFadeInActive(bool) {
    this.setState({
      fadeInActive: bool
    });
  }

  @Bind()
  setActiveSlide(index) {
    this.setState({
      activeSlideIndex: index
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Intro.js